import { onMount } from '../lifecycle/index.js';
import { clean } from '../clean-stores/index.js';
import { map } from '../map/index.js';
export function mapTemplate(init) {
  var Template = function Template(id) {
    if (!Template.cache[id]) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      Template.cache[id] = Template.build.apply(Template, [id].concat(args));
    }
    return Template.cache[id];
  };
  Template.build = function (id) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    var store = map({
      id: id
    });
    onMount(store, function () {
      var destroy;
      if (init) destroy = init.apply(void 0, [store, id].concat(args));
      return function () {
        delete Template.cache[id];
        if (destroy) destroy();
      };
    });
    return store;
  };
  Template.cache = {};
  if (process.env.NODE_ENV !== 'production') {
    Template[clean] = function () {
      for (var id in Template.cache) {
        Template.cache[id][clean]();
      }
      Template.cache = {};
    };
  }
  return Template;
}